import React from 'react';
import SettingsLayout from './SettingsLayout';
import RecruitersSection from './RecruitersSection';

/**
 * /hirewithus/settings/recruiters — manage third-party recruiters/vendors and
 * control which job descriptions each one can access. Rendered inside the
 * unified Settings shell. Reached from the Sidebar → Settings → Recruiters
 * sub-menu, or from a job's "Manage recruiters →" shortcut (?jobId=...).
 */
const RecruitersPage = () => {
  return (
    <SettingsLayout
      activeKey="recruiters"
      title="Settings"
      description="Manage your company profile, interview panel, and recruiter access."
    >
      <RecruitersSection />
    </SettingsLayout>
  );
};

export default RecruitersPage;
